var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.room.tariff && _vm.ownProduct)?_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"info--text",attrs:{"left":"","small":""}},[_vm._v("mdi-tag-text")]),_vm._v("\n    "+_vm._s(_vm.room.tariff)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }